import React from 'react';
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart } from 'recharts';

interface Props {
	chartData: {
		name: string;
		userRating: number;
	}[];
}

const ScorecardChart = ({ chartData }: Props) => {
	return (
		<>
			<div className="flex w-[100%] items-center justify-center pt-[20px]">
				<RadarChart
					className="scorecard-radar-chart-container"
					width={10}
					height={450}
					outerRadius={180}
					data={chartData}
				>
					<PolarGrid />
					<PolarAngleAxis
						fontSize={12}
						dataKey="name"
						tick={{
							width: 150,
						}}
					/>
					<PolarRadiusAxis
						tick={{
							dx: 5,
							dy: 5,
						}}
						fontSize={9}
						tickCount={11}
						angle={90}
						domain={[0, 1000]}
					/>
					<Radar name="Skill" dataKey="userRating" stroke="#7777E7" fill="#e5f0ff66" fillOpacity={0.7} />

					{/* commenting for now */}
					{/* <Radar name="Skill" dataKey="topCandidateRating" stroke="#FC0" fill="#e5f0ff66" fillOpacity={0.7} /> */}
				</RadarChart>
			</div>

			{/* commenting for now */}
			{/* <ScorecardChartLegend /> */}
		</>
	);
};

export default ScorecardChart;
